import { z } from 'zod'

// Shared vehicle type schema for UI components
export const VehicleTypesSchema = z.enum(['VAN', 'PANEL_VAN', 'CARGO_VAN', 'PICKUP'])
